import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';

export function useParkProfilePhoto({ parkId, width, height }: { parkId?: number; width: number; height: number }) {
  const publicBaseUrl = usePublicBaseUrl();

  if (!parkId) {
    return undefined;
  }

  return `${publicBaseUrl}/api/alltrails/areas/${parkId}/profile_photo?size=${width}w${height}h`;
}
